var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsDownFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92436 21.2608C9.60735 21.7491 10.451 21.5563 10.9584 21.094L16.4709 16.0712L16.4706 2.25H6.51074C5.13424 2.25 3.96979 3.26772 3.78549 4.63182L2.77034 12.1458C2.54741 13.7959 3.8305 15.264 5.49558 15.264L8.52189 15.264C7.85353 16.3597 7.49341 17.3611 7.44758 18.2707C7.38229 19.5663 7.95956 20.5711 8.92436 21.2608Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2072 15.75C21.1737 15.75 21.9572 14.9665 21.9572 14L21.9572 4.00002C21.9572 3.03353 21.1737 2.25002 20.2072 2.25002L17.8635 2.25002L17.8635 15.75H20.2072Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownFilled);
export default __webpack_public_path__ + "static/media/ThumbsDownFilled.d105b5f6b265e27de50957ceb15e8626.svg";
export { ForwardRef as ReactComponent };